import React, { useState, useEffect } from "react";
import {
  CardContainer,
  SideCardContainer,
  // SideCardcontent,
  SideCardContainer2,
} from "../all-containers/general";
import { Background } from "../background/background";
import { CardContents } from "../card/cardcontainer";
import { SectionItem } from "../section-item/sectionItem";
import styles from "./container.module.css";
import { Title } from "../titles/titles";
import { Ussd } from "../ussd/ussd";
import { Bank } from "../bank/BankNew";
// import { Wallets } from "../wallet/wallet";
import { PayAttitude } from "../payAttitude/pay";
// import { ModalContainer } from "../modalContainer/container";
import {
  InProccess,
  OTPOverlay,
  PaymentFailed,
  PaymentSuccess,
  PlsWait,
} from "../modal/container";
import { SVGS } from "../../assets/svgs";
import { NormalText } from "../normalText/normalText";
import { useDispatch, useSelector } from "react-redux";
import { Dispatach_New_Tab } from "../../redux/actions/account";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config.js";
import {
  getEmbedContext,
  notifyParent,
  applyEmbedTheme,
  getEmbedQueryString,
} from "../../utils/embed";
// let CryptoJS = require("crypto-js");
import logo3 from "../../assets/quickLogo.png";
import { BankTransfer } from "../BankTransfer/BankTransfer.jsx";
import { WqToast as toast } from "../../utils/themedToast";
import {
  useBankTransfer,
  useFetchBanksUssdList,
} from "../../hooks/use-api-fetchers.js";
import { BankTransferTestMode } from "../BankTransfer/BankTransferTestMode.jsx";
import { UssdTestMode } from "../ussd/UssdTestMode.jsx";

const {
  Ussd: USSD,
  bankIcon,
  credit_card,
  // wallet,
  // call_button,
  // cardSect,
  transferIcon,
  // logo3,
  // backLogo,
} = SVGS;

const getStoredProductData = () => {
  try {
    return JSON.parse(sessionStorage.getItem("product_data") || "null");
  } catch (e) {
    return null; // corrupt/partial value shouldn't crash the whole effect
  }
};

export const Container = () => {
  const navigate = useNavigate();
  const [modals, setModals] = useState("");
  const [tabs, setTabs] = useState(1);
  const active = useSelector((state) => state.tabs);
  const Dispatch = useDispatch();
  const [companyName, setCompanyName] = useState(
    () => getStoredProductData()?.merchant_business_name || null
  );
  const [menus, setMenus] = useState([]);
  const [searchParams] = useSearchParams();
  const [tranIdd, setTranId] = useState(null);
  // const [transactionDetails, setTransactionDetails] = useState({});
  // const [payWithTransfer, setPayWithTransfer] = useState(true);

  const { transferData, initBankTransfer } = useBankTransfer();

  const { banks, initUssdBankList } = useFetchBanksUssdList();

  // Embedded context (dashboard top-up iframe) + theme sync from the host app.
  const { isEmbedded, isTestMode } = getEmbedContext();

  useEffect(() => {
    applyEmbedTheme();

    // Persist the launch-time "source" param (e.g. "wayatopup") because the
    // later `navigate(/?_tranId=...)` call strips all other query params on
    // refresh. Without this, fetchPaymentPreferences would lose the signal
    // after the first render.
    const source = searchParams.get("wq_source");
    if (source) {
      sessionStorage.setItem("wq_source", source);
    }
  }, [searchParams]);

  useEffect(() => {
    const isCompleted = sessionStorage.getItem("paymentCompleted");
    const isAbandoned = sessionStorage.getItem("paymentAbandoned");
    const fallbackUrl = sessionStorage.getItem("fallbackUrl");
    const referrer = sessionStorage.getItem("referrer");

    if (isEmbedded) {
      sessionStorage.removeItem("paymentCompleted");
    }

    // todo check if tranid is expired and if it is close the page or dont run at all and clear session storage
    if (isCompleted === "true") {
      return;
    }

    if (isAbandoned === "true") {
      sessionStorage.removeItem("paymentAbandoned");

      const redirectUrl = fallbackUrl || referrer;

      if (redirectUrl) {
        window.location.replace(redirectUrl);
      } else {
        window.history.back();
      }

      return;
    }

    /*
      Build the payment-method list for a given merchant. Pulled out into its
      own function so it can be called the moment we know the merchant id,
      from either entry path:
        - payment-link / refresh: merchant id is already in product_data, so
          we call this at the top of the effect and the methods show instantly.
        - direct API (?_tranId=...): there is no product_data yet, so we call
          this right after the reference query returns the merchant id, instead
          of waiting on a sessionStorage round-trip and a re-render (which was
          the bug that left the list empty until a manual refresh).
    */
    const fetchPaymentPreferences = (merchantId) => {
      if (!merchantId) return;

      const paymentOptionsList = [];

      axios
        .get(
          `${config.API_ROOT}/wayapay-identity-manager/api/v1/waya-merchant/configuration/payment-preference?merchantId=${merchantId}`
        )
        .then((result) => {
          const paymentOption = result.data.data;
          if (paymentOption.payWithCardEnabled) {
            paymentOptionsList.push({
              title: "Card",
              description: "Mastercard, Verve, Visa",
              img: credit_card,
            });
          }

          if (paymentOption.payWithUSSDEnabled) {
            paymentOptionsList.push({
              title: "USSD",
              description: "Pay with USSD code via your mobile device",
              img: USSD,
            });
          }
          if (paymentOption.payWithWalletEnabled) {
            paymentOptionsList.push({
              title: "Pay with transfer",
              description: "Make payment to a unique account number",
              img: transferIcon,
            });
          }

          if (paymentOption.payWithBankEnabled && !isTestMode) {
            paymentOptionsList.push({
              title: "Bank",
              description: "Make payment from your Wayabank account",
              img: bankIcon,
            });
          }
          // TODO Uncomment on request
          // if (paymentOption.payWithPayAttitudeEnabled) {
          //   paymentOptionsList.push({
          //     title: "PayAttitude",
          //     description: "Pay with your phone number",
          //     img: call_button,
          //   });
          // }

          // Test-mode top-ups only work with Card on the gateway side, so hide
          // the other channels entirely rather than showing options that will
          // just fail. Scoped tightly (embedded + test key + wayatopup source)
          // so it can never fire for link payments, live top-ups, or the
          // non-embedded flow.
          const isTopUpSource = sessionStorage.getItem("wq_source") === "wayatopup" || searchParams.get("wq_source") === "wayatopup";

          if (isEmbedded && isTestMode && isTopUpSource) {
            const testMenus = [
              { title: "Card", description: "Mastercard, Verve, Visa", img: credit_card },
            ];
            if (paymentOption.payWithWalletEnabled) {
              testMenus.push({
                title: "Pay with transfer",
                description: "Make payment to a unique account number",
                img: transferIcon,
              });
            }
            if (paymentOption.payWithUSSDEnabled) {
              testMenus.push({
                title: "USSD",
                description: "Pay with USSD code via your mobile device",
                img: USSD,
              });
            }
            setMenus(testMenus);
            return;
          }


          // if (isEmbedded && isTestMode && isTopUpSource) {
          //   setMenus([
          //     { title: "Card", description: "Mastercard, Verve, Visa", img: credit_card, },
          //     {
          //       title: "Pay with transfer",
          //       description: "Make payment to a unique account number",
          //       img: transferIcon,
          //     },
          //     {
          //       title: "USSD",
          //       description: "Pay with USSD code via your mobile device",
          //       img: USSD,
          //     }
          //   ]);
          //   return;
          // }

          // Extract from the url if customParam is part of the options/params
          const transactionSource = JSON.parse(
            window.sessionStorage.getItem("transactionSource")
          );
          // Link name will be undefined at first initiation of transaction,
          // subsequent refreshes will have value
          if (transactionSource?.value === "linkPaymentPage") {
            if (transactionSource?.type === "recurrent") {
              setMenus([
                {
                  title: "Card",
                  description: "Mastercard, Verve, Visa",
                  img: credit_card,
                },
              ]);
            } else {
              setMenus(paymentOptionsList);
            }
          } else {
            setMenus(paymentOptionsList);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };

    // if (sessionStorage.getItem("product_data")) {
    //   setCompanyName(
    //     JSON.parse(sessionStorage.getItem("product_data") || "null")
    //       .merchant_business_name
    //   );
    // }
    const productData = getStoredProductData();
if (productData?.merchant_business_name) {
  setCompanyName(productData.merchant_business_name);
}

    const tranId1 = searchParams.get("_tranId");
    const tranId2 = sessionStorage.getItem("tranId");
    // let merchantId;
    // if (JSON.parse(sessionStorage.getItem("product_data"))) {
    //   merchantId = JSON.parse(sessionStorage.getItem("product_data"))?.customer
    //     ?.merchantId;
    // }
    const merchantId = getStoredProductData()?.customer?.merchantId;

    // If the merchant is already known (payment-link flow or a refresh),
    // load the payment methods right away.
    if (merchantId) {
      fetchPaymentPreferences(merchantId);
    }

    if (tranId1 && sessionStorage.getItem("paymentCompleted") !== "true") {
      const ENDPOINT = `${config.API_ROOT_ADDRESS}/api/v1/reference/query/${tranId1}`;
      axios
        .get(ENDPOINT)
        .then((response) => {
          if (response.data.data.Status !== "PENDING") {
            // Embedded top-up: do not redirect to the merchant callback inside
            // the iframe. Tell the dashboard to confirm + close (its poll reads
            // the authoritative status from the status endpoint).
            if (isEmbedded) {
              notifyParent("success");
              return;
            }
            // clear session and redirect to demo page
            const merchantId = response?.data?.data.merchantId;
            if (merchantId) {
              axios
                .get(
                  `${config.API_ROOT}/wayapay-identity-manager/api/v1/waya-merchant/fetch/callback?param=${merchantId}`
                )
                .then((result) => {
                  const callback = result.data.data.webCallbackUrl;
                  sessionStorage.clear();
                  if (typeof callback !== "undefined" && callback != null) {
                    window.location.href = callback;
                  } else {
                    if (sessionStorage.getItem("referrer")) {
                      window.location.href = sessionStorage.getItem("referrer");
                    } else {
                      window.history.go(-1);
                    }
                  }
                })
                .catch((err) => {
                  console.error(err)
                });
            } else {
              if (sessionStorage.getItem("referrer")) {
                window.location.href = sessionStorage.getItem("referrer");
              } else {
                window.history.go(-1);
              }
            }
          } else {
            let storage = sessionStorage;
            const resolvedMerchantId = response?.data?.data?.merchantId;
            //         if (sessionStorage.getItem("transactionSource") === "demoPaymentPage" || !sessionStorage.getItem("transactionSource")) {
            if (
              sessionStorage.getItem("transactionSource") === "demoPaymentPage"
            ) {
              // If it is from demoPage
              storage.setItem(
                "fallbackUrl",
                document.referrer + "?ref=" + tranId1
              );
            } else {
              // If it is payment link/subscription
              axios
                .get(
                  `${config.API_ROOT}/wayapay-identity-manager/api/v1/waya-merchant/fetch/callback?param=${resolvedMerchantId}`
                )
                .then((result) => {
                  const callback = result.data.data.webCallbackUrl?.trim();
                  const redirectUrl = callback || "https://wayaquick.com";
                  storage.setItem("fallbackUrl", redirectUrl + "?ref=" + tranId1);
                })
                
                .catch((err) => {
                  console.error(err);
                });
            }

            const transactionDetails = {
              amount: response.data.data.Amount,
              description: response.data.data.Description,
              fee: response.data.data.Fee,
              customer: {
                name: response.data.data.customer.name,
                email: response.data.data.customer.email,
                phoneNumber: response.data.data.customer.phoneNumber,
                customerId: response.data.data.customer.customerId,
                merchantId: response.data.data.merchantId,
              },
              product_name: response.data.data.productName,
              merchant_business_name: response.data.data.businessName ?? (productData ? productData?.merchant_business_name : null),
              recurrentPayment: response?.data?.data?.recurrentPayment,
            };
            

            // Write product_data BEFORE flipping tranId state, so any re-run
            // of this effect reads a populated merchant id rather than racing
            // an empty sessionStorage.
            storage.setItem("tranId", tranId1);
            // setTransactionDetails(transactionDetails);
            storage.setItem("product_data", JSON.stringify(transactionDetails));
            
            // setCompanyName(transactionDetails.merchant_business_name);
            setTranId(tranId1);

            // Direct-API entry: the merchant id was unknown at the top of the
            // effect, so load the payment methods now that we have it. No
            // refresh required.
            if (!merchantId && resolvedMerchantId) {
              fetchPaymentPreferences(resolvedMerchantId);
            }
          }
        })
        .catch((err) => {
          // clear session and redirect to demo page
          const callback = window.sessionStorage.getItem("fallbackUrl");
          // window.location.href= `${callback}?_msg=can't_validate_transaction_ID`;
        });
    } else if (
      tranId2 &&
      sessionStorage.getItem("paymentCompleted") !== "true"
    ) {
      const ENDPOINT = `${config.API_ROOT_ADDRESS}/api/v1/reference/query/${tranId2}`;
      axios
        .get(ENDPOINT)
        .then((response) => {
          //console.log(response);
          if (response.data.data.Status === "PENDING") {
            // append the value to url query string
            // navigate(`/?_tranId=${tranId2}`);
            const embedQS = getEmbedQueryString();
          navigate(`/?_tranId=${tranId2}${(embedQS && isEmbedded) ? `&${embedQS}` : ""}`);
          } else {
            // clear session and redirect to demo page
            const callback = window.sessionStorage.getItem("fallbackUrl");
            const referrer = window.sessionStorage.getItem("referrer");
            if (typeof callback !== "undefined" && callback != null) {
              sessionStorage.clear();
              window.location.href = callback;
            } else {
              if (typeof referrer !== "undefined" && referrer != null) {
                window.location.href = referrer;
                sessionStorage.clear();
              } else {
                window.history.go(-1);
                sessionStorage.clear();
                window.location.href = "https://wayaquick.com";
              }
            }
          }
        })
        .catch((err) => {
          //console.log(err);
          // clear session and redirect to demo page
          const callback = window.sessionStorage.getItem("fallbackUrl");
          sessionStorage.clear();
          if (typeof callback !== "undefined" && callback != null) {
            window.location.href = callback;
          } else {
            window.history.go(-1);
          }
        });
    } else {
      // sessionStorage.clear();
      const callback = window.sessionStorage.getItem("fallbackUrl");
      sessionStorage.clear();
      if (typeof callback !== "undefined" && callback != null) {
        window.location.href = callback;
      } else {
        window.history.go(-1);
      }
      navigate(`/demo/?_msg=transaction_ID_must_be_provided`);
    }
  }, [tranIdd]);

  const handleTabChange = async (value) => {
    Dispatach_New_Tab(Dispatch, value);

    if (value === "Pay with transfer") {
      await initBankTransfer();
    } else if (value === "USSD") {
      await initUssdBankList();
    }
  };
  const renderItems = () => {
    return (
      <>
        <div style={{ display: active === "Card" ? "block" : "none" }}>
          <CardContents modals={setModals} overTabs={tabs} />
        </div>
        <div style={{ display: active === "USSD" ? "block" : "none" }}>
          {isTestMode ? <UssdTestMode banks={banks} /> : <Ussd banks={banks} />}
        </div>
        <div style={{ display: active === "Bank" ? "block" : "none" }}>
          {isTestMode ? <Bank /> : <Bank />}
        </div>
        <div
          style={{ display: active === "Pay with transfer" ? "block" : "none" }}
        >
          {/* <BankTransfer transferData={transferData} /> */}
          {isTestMode ? (
            <BankTransferTestMode transferData={transferData} />
          ) : (
            <BankTransfer transferData={transferData} />
          )}
        </div>
        <div style={{ display: active === "PayAttitude" ? "block" : "none" }}>
          <PayAttitude />
        </div>
      </>
    );
  };

  const cancelPageHandler = async () => {
    const fallbackUrl = sessionStorage.getItem("fallbackUrl");
    const referrer = sessionStorage.getItem("referrer");
    const tranId = sessionStorage.getItem("tranId");

    const redirectUrl = fallbackUrl || referrer;

    // Embedded top-up (inside the dashboard iframe): never redirect. Abandon the
    // transaction for a clean record, then tell the dashboard to close the
    // iframe + modal.
    if (isEmbedded) {
      try {
        if (tranId) {
          await axios.put(
            `${config.API_ROOT_ADDRESS}/api/v1/transaction/abandon/${tranId}`,
            { status: "ABANDONED" }
          );
          sessionStorage.clear();
        }
      } catch (err) {
        // ignore: close regardless
      }
      notifyParent("cancel");
      return;
    }

    try {
      if (tranId) {
        await axios.put(
          `${config.API_ROOT_ADDRESS}/api/v1/transaction/abandon/${tranId}`,
          {
            status: "ABANDONED",
          }
        );
      }

      toast.success("Transaction cancelled");

      sessionStorage.clear();

      if (redirectUrl) {
        window.location.replace(redirectUrl);
      } else {
        window.history.back();
      }
    } catch (err) {
      console.error(err);

      if (redirectUrl) {
        window.location.replace(redirectUrl);
      }
    }
  };

  return (
    <Background>
      {/* <Toaster position="top-right" /> */}
      <div className={`${styles.container}`}>
        <div className={`${styles.controls}`}>
          <div className={styles.logs}>
            <div className={styles.logostyles}>
              <img src={logo3} alt="" width="150px" />
              <button
                onClick={() => cancelPageHandler()}
                className={styles.cancelBtn}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.85571 6.5L13 11.6443V13H11.6443L6.5 7.85571L1.35571 13H0V11.6443L5.14429 6.5L0 1.35571V0H1.35571L6.5 5.14429L11.6443 0H13V1.35571L7.85571 6.5Z"
                    fill="white"
                  />
                </svg>
                Cancel
              </button>
            </div>
          </div>
        </div>
        <CardContainer>
          <div className={styles.secondOption}>
            {menus?.map((el) => (
              <div
                active={active}
                onClick={() => handleTabChange(el.title)}
                className={`${styles.eachMobileMenu} ${
                  el.title === active && styles.active
                }`}
              >
                <img src={el.img} width="30" height="30" alt="" />
              </div>
            ))}
          </div>
          <SideCardContainer classStyles={styles.hidden}>
            <p
              style={{
                paddingLeft: "18px",
                marginBottom: 2,
                fontSize: "13px",
              }}
            >
              Make payment to:
            </p>

            <h5
              style={{
                paddingLeft: "18px",
                textTransform: "uppercase",
                marginTop: 4,
                fontSize: 16,
              }}
            >
              {companyName}
            </h5>
            <Title
              size={15}
              title={
                active === "Card"
                  ? "SELECT YOUR PREFERRED PAYMENT METHOD"
                  : `SELECT PAYMENT METHOD`
              }
            />
            {menus?.map((el) => (
              <SectionItem
                title={`${el.title}`}
                description={`${el.description}`}
                active={active}
                setActive={handleTabChange}
              >
                <img src={el.img} width="30" height="30" alt="" />
              </SectionItem>
            ))}
          </SideCardContainer>
          <SideCardContainer2 classStyles={styles.sideMenu}>
            {renderItems()}
          </SideCardContainer2>
        </CardContainer>
        <div className={`${styles.bottom}`}>
          <div className={styles.formGroup}>
            <div className={styles.inputWrap}>
              <fieldset className={styles.fieldset}>
                <legend align="center">
                  <img src={SVGS.lock_icon} alt="wayaquick logo" /> Payment
                  secured by WayaQuick
                </legend>
                <img src={SVGS.sponsors_icon} alt="wayaquick logo" />
              </fieldset>
            </div>
          </div>
          <div style={{ width: "100%", marginTop: 14, marginBottom: 5 }}>
            <NormalText size={12} align="center">
              Accept, Process and Disburse Digital Payments for your business
              <br />
              <a
                href="https://wayaquick.com"
                target="_blank"
                style={{ color: "red" }}
                rel="noopener noreferrer"
              >
                {" "}
                Learn More
              </a>
            </NormalText>
          </div>
        </div>
      </div>

      {/* MODALS */}
      {modals === "proccess" && (
        <InProccess
          cancel={() => {
            setModals("");
            setTabs(1);
          }}
        />
      )}
      {modals === "otp" && (
        <OTPOverlay
          cancel={() => {
            setModals("");
            setTabs(1);
          }}
        />
      )}
      {modals === "success" && <PaymentSuccess />}
      {modals === "failed" && <PaymentFailed />}
      {modals === "wait" && <PlsWait />}
    </Background>
  );
};
